import * as React from "react";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import { logoutStatic } from "../../StateManagement/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Components/Api/Api";
import { InputFormat } from "../Components/FormOptions/InputFormat";
import { DropDownFormat } from "../Components/FormOptions/DropDownFormat";
import TelInput from "../Components/FormOptions/TelInput";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { fetchData } from "../../Cpanel/Components/Utilities";
export const SecondStep = ({ onNext, insuranceId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const province = useSelector((state) => state?.province?.province);

  const [checkLogin, setCheckLogin] = useState(null);

  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setCheckLogin(data?.UserId);
    reset({ ...defaultValues });
  };
  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);

  useEffect(() => {
    dispatch(getProvince());
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const data = mapOptions(province);
    setProvinceList(data);
  }, []);

  const defaultValues = {
    address: "",
    mob: "",
    born: "",
    borncity: "",
    city: "",
    fathername: "",
    postalcode: "",
    province: "",
    sex: null,
    no: "",
    unit: "",
  };
  const {
    handleSubmit,
    control,
    register,
    reset,
    setValue,
    formState: { errors },
    watch,
  } = useForm({ defaultValues });

  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("province"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("province")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
    });
  }, [watch("province")]);

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("step", 2);
    bodyFormData.append("mob", 2);
    bodyFormData.append("id", insuranceId);
    bodyFormData.append("fathername", data?.fathername);
    bodyFormData.append("born", data?.born);
    bodyFormData.append("borncity", data?.borncity);
    bodyFormData.append("postalcode", data?.postalcode);
    bodyFormData.append("sex", data?.sex);
    bodyFormData.append("married", data?.married);
    bodyFormData.append("province", data?.province);
    bodyFormData.append("city", data?.city);
    bodyFormData.append(
      "address",
      data?.address + "|" + data?.no + "|" + data?.unit
    );

    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "createinsurance",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        onNext();

        if (responseGlobal?.data?.UserId === 0) {
          dispatch(logoutStatic());
          navigate("/");
        }
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  return (
    <div dir="rtl" className="m-5">
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="fathername"
              type={"text"}
              label="نام پدر"
              errors={errors}
            />
          </Col>

          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="born"
              type={"text"}
              label="محل تولد"
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="borncity"
              type={"text"}
              label="محل صدور"
              errors={errors}
            />
          </Col>
          <Col className="col-12 col-lg-6">
            <TelInput
              label="کد پستی"
              type="text"
              name="postalcode"
              control={control}
              defaultValue={""}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6 ">
            <Form.Group
              className="mb-3 d-flex flex-column  drop-down-group "
              controlId="formBasicEdu"
            >
              <Form.Label className="fw-bold pb-1">جنسیت </Form.Label>
              <Form.Select
                aria-label="Default select example"
                {...register("sex", {
                  required: "جنسیت الزامی است",
                })}
                className={"w-75"}
              >
                <option value="" disabled>
                  انتخاب کنید...
                </option>
                <option value="1">مرد</option>
                <option value="2">زن</option>
              </Form.Select>
            </Form.Group>
            {errors.sex && (
              <div className="text-danger">{errors.sex.message}</div>
            )}
          </Col>
          <Col className=" col-12 col-lg-6 ">
            <Form.Group
              className="mb-3 d-flex flex-column  drop-down-group "
              controlId="formBasicEdu"
            >
              <Form.Label className="fw-bold pb-1">وضعیت تاهل </Form.Label>
              <Form.Select
                aria-label="Default select example"
                {...register("married", {
                  required: "تاهل الزامی است",
                })}
                className={"w-75"}
              >
                <option value="" disabled>
                  انتخاب کنید...
                </option>
                <option value="1">مجرد</option>
                <option value="2">متاهل</option>
              </Form.Select>
            </Form.Group>
            {errors.sex && (
              <div className="text-danger">{errors.sex.message}</div>
            )}
          </Col>
        </Row>
        <Row>
          <Col className="col-12 col-lg-6">
            <DropDownFormat
              control={control}
              label={"استان"}
              options={ProvinceList}
              errors={errors}
              name={"province"}
            />
          </Col>
          <Col className="col-12 col-lg-6">
            <DropDownFormat
              control={control}
              label={"شهر"}
              options={cityList}
              errors={errors}
              name={"city"}
            />
          </Col>
        </Row>
        <Row>
          <Col className="col-8 ">
            <InputFormat
              control={control}
              name="address"
              type={"textarea"}
              label="آدرس"
              errors={errors}
            />
          </Col>
          <Col className=" col-2">
            <InputFormat
              control={control}
              name="no"
              type={"text"}
              label="پلاک "
              errors={errors}
            />
          </Col>

          <Col className=" col-2">
            <InputFormat
              control={control}
              name="unit"
              type={"text"}
              label="واحد"
              errors={errors}
            />
          </Col>
        </Row>

        <Col
          className="px-5 col-12 col-lg-12 d-flex gap-2 align-items-center"
          dir="ltr"
        >
          <Button variant="primary" type="submit">
            بعدی
          </Button>
        </Col>
      </Form>
    </div>
  );
};
